import styled from '@emotion/styled'

const Stack = styled.div<{ space: string }>`
  display: grid;
  row-gap: ${props => props.space};
`

export default Stack
